import stopSignUrl from '@/assets/images/stop-sign-exclusion.svg';

export function lineStringFromGeometry(geometry) {
  if (!geometry?.coordinates?.length) {
    return null;
  }
  const linestring = new H.geo.LineString();
  geometry.coordinates.forEach((pair) => {
    const lng = Number(pair[0]);
    const lat = Number(pair[1]);
    if (Number.isNaN(lat) || Number.isNaN(lng)) {
      return;
    }
    linestring.pushPoint({ lat, lng });
  });
  return linestring.getPointCount() >= 2 ? linestring : null;
}

export function lineStringFromExclusionItem(item) {
  if (!item) {
    return null;
  }
  try {
    if (item.segment_polyline) {
      const linestring = H.geo.LineString.fromFlexiblePolyline(item.segment_polyline);
      if (linestring && linestring.getPointCount() >= 2) {
        return linestring;
      }
    }
  } catch (e) {
    // fall through to geometry
  }
  return lineStringFromGeometry(item.segment_geometry);
}

export function getExclusionMarkerPosition(item) {
  if (item?.click_lat != null && item?.click_lng != null) {
    return { lat: Number(item.click_lat), lng: Number(item.click_lng) };
  }
  const linestring = lineStringFromExclusionItem(item);
  if (!linestring) {
    return null;
  }
  const mid = Math.floor(linestring.getPointCount() / 2);
  return linestring.extractPoint(mid);
}

export function createStopMarkerIcon() {
  return new H.map.Icon(stopSignUrl, {
    size: { w: 32, h: 32 },
    anchor: { x: 16, y: 32 },
  });
}

export function getExclusionConditionLines(item) {
  if (Array.isArray(item?.condition_lines) && item.condition_lines.length) {
    return item.condition_lines;
  }
  const raw = item?.condition || item?.summary || 'Passage prohibited';
  if (raw === 'Passage prohibited') {
    return [raw];
  }
  return raw
    .split(/;\s*/)
    .flatMap((part) => part.split(/,\s*/))
    .filter(Boolean);
}

export function buildExclusionBubbleContent(item) {
  const escape = (s) => String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;');
  const name = escape(item.name || 'Road restriction');
  const conditionLines = getExclusionConditionLines(item).map(escape);
  const sourceLabel = escape(
    item.source_label
      || (item.source === 'system' ? 'Global' : item.source === 'user' ? 'User' : ''),
  );
  const conditionsHtml = conditionLines
    .map((line) => `<div class="exclusion-bubble-condition">${line}</div>`)
    .join('');

  return [
    '<div class="exclusion-bubble">',
    `<div class="exclusion-bubble-title" title="${name}">${name}</div>`,
    '<hr class="exclusion-bubble-divider" />',
    `<div class="exclusion-bubble-conditions">${conditionsHtml}</div>`,
    '<hr class="exclusion-bubble-divider" />',
    `<div class="exclusion-bubble-source">${sourceLabel}</div>`,
    '</div>',
  ].join('');
}
